
  export default {
    scrollToTop: true,
    layout: 'error-page',
     head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'description',
            name: 'description',
            content: 'goa app login, goa login app, Goa Login, Goa App, Goa App Register, goa App Online, Goa App Invitation Code'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'goa app login, goa login app, Goa Login, Goa App, Goa App Register, goa App Online, Goa App Invitation Code'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'goa app login, goa login app, Goa Login, Goa App, Goa App Register, goa App Online, Goa App Invitation Code'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: 'goa app login, goa login app, Goa Login, Goa App, Goa App Register, goa App Online, Goa App Invitation Code'
          }
        ],
      }
    },
    data() {
      return {
        title:'Goa App Login',
        showPass: false,
        form: {
          phoneNumberorEmail: null,
          password: null
        },
        //Form error variables
        errors: {
          formError: null,
          formErrMsg: "Opps! Something went wrong, please try again."
        },
        // Form submit variables
        submit: {
          loading: false,
          success: false,
          errored: false
        }
      }
    },
    // Check login token
    mounted() {
      if (!localStorage.getItem("authToken")) {
        this.$router.push({
          path: '/accounts/login/'
        })
      } else {
        this.$router.back()
      }
    },

    methods: {
      // To clear the submit error message
      clearFormErrMsg() {
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
      },
      // Validate and Submit form data to LOGIN
      sendMessage() {
        // Clear all submit errors before API call
        this.errors.formError = null;
        this.submit.success = false
        this.submit.errored = false
        // Validate all fields for making the API call, throw error and not call API if validation errors are present
        this.$refs.registrationForm.validate().then((success) => {
          if (!success) {
            // run your error code here
            this.errors.formError = "One or more incorrect fields present, please fix.";
          } else {
            // If Valid form
            // Create url encoded formData instance to pass the data to the API
            var formData = new URLSearchParams();
            formData.append("phoneOrEmail", this.form.phoneNumberorEmail.trim());
            formData.append("password", this.form.password.trim());
            let data = {
              phone: this.form.phoneNumberorEmail.trim(),
              password: this.form.password.trim()
            }
            // Add header for the API
            const headers = {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
            this.submit.loading = true;
            // AXIOS api call to add SIGNIN api
            this.$axios
              .post("/auth/signin", formData, {
                headers: headers
              })
              .then(response => {
                this.submit.success = true
                this.submit.errored = false
                let value = this.getCryptKey(response.data);
                localStorage.setItem("authToken", "bearer " + value.token);
                this.$store.commit('login', value.token);
                this.myProfile(value.token);

              })
              .catch(error => {
                if (error.response)
                  this.errors.formErrMsg = this.getCryptKey(error.response.data)
                this.submit.success = false
                this.submit.errored = true
              })
              .finally(() => {
                this.submit.loading = false
              });
          }
        });
      },
      myProfile(token) {
        // Add header for the API
        const headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': "bearer " + token,
        }
        // AXIOS api call to add SIGNIN api
        this.$axios
          .get("/api/users/me/", {
            headers: headers
          })
          .then(response => {
            // New flow
            let value = this.getCryptKey(response.data);
            localStorage.setItem("profile", JSON.stringify(value));
            this.$store.commit('profile', value.username);
            this.$router.back()
          })
          .catch(error => {});
      },
    }
  }

